import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { GVL } from '@iabtcf/core';
import { connect } from 'react-redux';

import gvl from '@module/consent-manager/gvl';
import I18n from '@module/i18n';
import { consentTracker } from '@module/consent-manager';

import Button from '@component/form/element/button';

import {
  Intro,
  AcceptButton,
  SaveButton,
  RejectButton,
  PurposeList,
  VendorList,
} from '@component/consent-manager';

export const ConsentWall = ({ closePanel, language }) => {
  const [showPreferences, setShowPreferences] = useState(false);
  /* Firefox scrolling fix */
  const [isFullHeight, setFullHeight] = useState(false);

  const [gvlLanguage, setGvlLanguage] = useState({});

  useEffect(() => consentTracker.showModal(), []);

  useEffect(() => {
    async function changeLang() {
      let supportedLang = language;

      // IAB uses NO while WeTransfer users NB and they are both the same thing
      if (supportedLang === 'nb') {
        supportedLang = 'no';
      }

      // changeLanguage will fetch the language file provided by IAB but hosted
      // by us. GVL.baseUrl is the path where the language files are located.
      await gvl.changeLanguage(supportedLang);

      // We are deliberately using the GVL language cache to avoid race
      // conditions.
      const gvlLang = GVL.LANGUAGE_CACHE.get(supportedLang.toUpperCase());

      setGvlLanguage(gvlLang);
    }

    changeLang();
  }, [language]);

  const handleOnClick = () => closePanel();

  const handlePrivacyPrefClick = () => {
    setShowPreferences(true);
    setFullHeight(true);
    consentTracker.clickPrivacyPreferences();
  };

  const content = {
    title: I18n.t('transfer.consent-manager.headline'),
    preferences: I18n.t('transfer.consent-manager.manage-cookies'),
  };

  return (
    <div
      className={`welcome__content welcome__cookie-notice ${
        isFullHeight ? 'welcome__cookie-notice-full-height' : ''
      }`}
    >
      <div className="welcome__cookie-notice-title">{content.title}</div>
      {showPreferences ? (
        <React.Fragment>
          <Intro>
            <RejectButton onClick={handleOnClick} context="intro_preference" />
            <SaveButton onClick={handleOnClick} context="intro_preference" />
            <AcceptButton onClick={handleOnClick} context="intro_preference" />
          </Intro>

          <div className="welcome__consent-preferences">
            <PurposeList gvlLanguage={gvlLanguage} />

            <div className="welcome__buttons ">
              <Button
                text={I18n.t('transfer.consent-manager.button-reject')}
                className="welcome__button welcome__button--decline welcome__button--hidden"
              />
              <SaveButton
                onClick={handleOnClick}
                context="purpose_preference"
              />
              <AcceptButton
                onClick={handleOnClick}
                context="purpose_preference"
              />
            </div>

            <VendorList gvlLanguage={gvlLanguage} />

            <div className="welcome__buttons welcome__buttons-vendor-list">
              <Button
                text={I18n.t('transfer.consent-manager.button-reject')}
                className="welcome__button welcome__button--decline welcome__button--hidden"
              />
              <SaveButton onClick={handleOnClick} context="vendor_preference" />
              <AcceptButton
                onClick={handleOnClick}
                context="vendor_preference"
              />
            </div>
          </div>
        </React.Fragment>
      ) : (
        <Intro>
          <RejectButton onClick={handleOnClick} context="intro_splash" />
          <Button
            text={content.preferences}
            className="welcome__button welcome__button--preferences"
            onClick={handlePrivacyPrefClick}
          />
          <AcceptButton onClick={handleOnClick} context="intro_splash" />
        </Intro>
      )}
    </div>
  );
};

ConsentWall.propTypes = {
  closePanel: PropTypes.func.isRequired,
  language: PropTypes.string,
};

const mapStateToProps = ({ session }) => {
  const language = session.language;
  return { language };
};

export const ConnectedConsentWall = connect(mapStateToProps)(ConsentWall);
